import ContentProviderEndpoint from '../../Content/ContentProviderEndpoint';
import { Observable, ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { FundNote } from '../../Kentico/DigitalDesign/fund_note';

export default class FundNoteProxy {
  digitalDesignContent: ContentProviderEndpoint;
  fundNoteSubject: ReplaySubject<FundNote[]>;
  fundNoteWasCalled: boolean;

  constructor(digitalDesignContent: ContentProviderEndpoint) {
    this.digitalDesignContent = digitalDesignContent;
    this.fundNoteSubject = new ReplaySubject<FundNote[]>();
    this.fundNoteWasCalled = false;
  }

  getFundNoteList(): Observable<FundNote[]> {
    if (!this.fundNoteWasCalled) {
      this.fundNoteWasCalled = true;
      this.digitalDesignContent
        .items<FundNote>()
        .type('fund_note')
        .orderByDescending('elements.baseDatepublished')
        .toObservable()
        .pipe(map((x) => x.items))
        .subscribe({
          next: (note) => this.fundNoteSubject.next(note),
          error: (err) => {
            console.error('Error in getFundNoteList:', err);
            this.fundNoteSubject.error(err);
          },
        });
    }
    return this.fundNoteSubject;
  }
}
